import { useDataProvider, useNotify, useRefresh, useTranslate } from "ra-core";

import type { CrmDataProvider } from "../providers/types";

/**
 * Runs an invoicing RPC wrapper of the data provider, notifies on success and
 * refetches the lists. Resolves to the (Spanish) error message the RPC raised
 * (role, transition and validation are enforced server-side), or null.
 */
export const useInvoicingRun = () => {
  const dataProvider = useDataProvider<CrmDataProvider>();
  const notify = useNotify();
  const refresh = useRefresh();
  const translate = useTranslate();

  const run = async (
    action: (provider: CrmDataProvider) => Promise<void>,
    doneKey: string,
  ): Promise<string | null> => {
    try {
      await action(dataProvider);
      notify(doneKey, { type: "success" });
      refresh();
      return null;
    } catch (error) {
      return error instanceof Error && error.message
        ? error.message
        : translate("crm.operations.error");
    }
  };

  return run;
};
